// # Types
export const grid = {
   sizes: { xxl: "xxl", xl: "xl", l: "l", m: "m", s: "s", xs: "xs" },
   sizesNumber: { xxl: 6, xl: 5, l: 4, m: 3, s: 2, xs: 1 },
} as const;

export const scrollAnimationProps = { duration: 0, animateOnce: true, animateIn: "scrollAnimation" } as const;

export const timelineToggle = {
   open: "open",
   fold: "fold",
} as const;
